// extracted by mini-css-extract-plugin
module.exports = {"googleLogo":"GoogleLogo_googleLogo__1O4NR"};